<template>
  <div>
    <fieldset>
      <legend class="flex justify-between items-center w-full">
        <span class="text-neutral-900 font-medium md:font-bold">{{ showLabel ? $t('pets.pets-label') : '' }}</span>
        <button
          v-if="isAddNewPetEnabled"
          type="button"
          class="flex items-center text-neutral-900 underline text-sm"
          @click="addPet"
        >
          {{ $t('pets.add-a-pet') }}
        </button>
      </legend>
      <div
        v-if="loading"
        class="w-full flex justify-center items-center py-2"
      >
        <fa
          :icon="['fas', 'bone']"
          class="text-3xl text-ocean-900 fa-spin"
        />
      </div>
      <div
        v-else
        :class="[hasOnePet ? 'lg:grid-cols-1' : 'lg:grid-cols-2']"
        class="divide-y divide-gray-200 lg:divide-y-0 lg:grid lg:gap-4 lg:mt-2 lg:mb-4"
      >
        <vetster-search-checkbox-input
          v-for="pet in getPets"
          :key="pet.uuid"
          v-model="selectedPet"
          :value="pet.uuid"
          :label="pet.name"
          type="radio"
          :data-testid="`pet-btn-${pet.uuid}`"
          @update:modelValue="choosePet(pet)"
        />
      </div>
    </fieldset>
    <vetster-pet-slide-over
      v-if="isAddNewPetEnabled"
      ref="addPetSlideOver"
      @pet-saved="selectPet"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import VetsterPetSlideOver from '@/brand-components/VetsterPetSlideOver';
import VetsterSearchCheckboxInput from '@/brand-components/VetsterSearchCheckboxInput';
import useSearchPets from '@/composables/use-search-pets';
import PetIcons from '@/mixins/PetIcons';

export default {
  name: 'VetsterShowClientPets',

  components: {
    VetsterPetSlideOver,
    VetsterSearchCheckboxInput,
  },

  mixins: [PetIcons],

  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    const { choosePet } = useSearchPets();

    return {
      choosePet,
    };
  },

  data() {
    return {
      selectedPet: null,
      loading: true,
    };
  },

  computed: {
    ...mapGetters('pets', [
      'getPets',
      'hasOnePet',
      'hasPets',
    ]),

    ...mapGetters('search', [
      'getInputs',
      'getSearchPet',
    ]),

    isAddNewPetEnabled() {
      return this.$statsig.ready && this.$statsig.checkGate('search_add_new_pet');
    },
  },

  watch: {
    getSearchPet: {
      handler(newValue) {
        if (!newValue && this.hasPets) {
          this.selectedPet = this.getPets[0].uuid;
        }
      },
      immediate: true,
    },
    selectedPet(value) {
      this.$store.commit('search/setTempInputs', {
        pet_uuid: value,
        species_treated: this.getPets.find((pet) => pet.uuid === value).species,
      });
    },
  },

  async created() {
    if (!this.getPets?.length) {
      await this.$store.dispatch('pets/fetchPets');
    }
    this.loading = false;
  },

  mounted() {
    const pet = this.getInputs.pet_uuid;

    if (pet) {
      this.selectedPet = pet;
    }
  },

  methods: {
    addPet() {
      this.$refs.addPetSlideOver.open();
    },
    selectPet(pet) {
      this.selectedPet = pet.uuid;
    },
  },
};
</script>
